import React from 'react';

import Section from '@glass/shared/components/Section/Section';

const LoadingSection = React.forwardRef((props, ref) => <Section {...props} ref={ref} loading />);

export default LoadingSection;
